<template>
  <div class="mb-2">
  <vx-card ref="helloAndWelcomeCard" class="hello-and-welcome rounded-md" :class="{'border-2 border-solid': border}" @remove="removeHandler" cardBackground="#FCD12A">
    <div v-if="$store.getters.isLargeScreen">
      <vs-row class="m-2">
        <vs-col class="px-6 flex flex-wrap content-center" vs-w="9">
          <!-- <div> -->
            <h1 class="font-bold lg:text-5xl text-3xl break-normal">Hello and welcome,</h1>
            <p class="mt-2 text-dark">
              With improvee.io, you will pursue meaningful things by actually doing them because the harsh truth is that nothing will work unless you do.
            </p>

            <p class="font-bold mt-2 text-dark">
              Become a designer of your life
            </p>

            <div class="w-full mt-2">
              <vs-button @click.stop="openOnboarding" class="shadow-2xl track-open-a-setup-guide">
                open a setup guide
              </vs-button>
              <vs-button @click.stop="doItLater" type="flat">
                I'll do it later.
              </vs-button>
            </div>

          <!-- </div> -->
        </vs-col>

        <vs-col class="flex flex-wrap content-center justify-center" vs-w="3">
          <img style="max-width: 180px" src="@/assets/images/onboarding/guitar.png"/>
        </vs-col>
      </vs-row>
    </div>
    <div v-else class="p-4">
      <h1 class="font-bold mb-2 text-dark">Hello and welcome,</h1>
      <p class="mb-2 text-dark">
        With improvee.io, you will pursue meaningful things by actually doing them because the harsh truth is that nothing will work unless you do.
      </p>

      <p class="font-bold mt-2 text-dark">
        Become a designer of your life
      </p>

      <div class="w-full mt-2">
       <vs-button @click.stop="openOnboarding" class="shadow track-open-a-setup-guide">
          open a setup guide
        </vs-button>

        <vs-button @click.stop="doItLater" type="flat">
          I'll do it later.
        </vs-button>
         </div>
      </div>


  </vx-card>


</div>
</template>
<script>

// import { midnight, isPast, daysFromDate } from '@/helpers/date'
export default {
  components: {
  },
  props: [],
  data () {
    return {
      border: false
    }
  },
  methods: {
    removeHandler () {
      this.border = false
      this.$store.dispatch('ADDITIONAL_USER_INFO', { helloAndWelcomeClosed: true })
    },
    openOnboarding () {
      this.$store.dispatch('ADDITIONAL_USER_INFO', { helloAndWelcomeStarted: true, helloAndWelcomeStartedFromCard: true })
      this.$store.commit('SET_SHOW_SETUP', true)
    },
    doItLater () {
      this.$refs['helloAndWelcomeCard'].removeCard()
    },
    closeCardAnimationDemo (card) {
      card.removeRefreshAnimation(3000)
    }
  }
}
</script>

<style scoped lang="scss">
.hello-and-welcome {
  .main-title {
    font-size: 3.5rem;
  }
}
</style>

<style lang="scss">

.hello-and-welcome {
  .vx-card__header {
    padding: 1rem 0.2rem 1rem 0.2rem!important
  }

  .vx-card__body {
    padding: 1rem 0.2rem 1rem 0.2rem!important
  }
  .vx-card {
    border-radius: 2rem;
  }
}
</style>
